import Breadcrumbs from 'core/components/common/Breadcrumbs';
import { useLinks } from 'core/components/linksContext';
import { container, pageHeader } from 'core/style';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import React from 'react';

const Heatmap: React.FC<WithStyles<typeof styles>> = ({ classes }) => {
    const links = useLinks();

    return (
        <>
            <div className={classes.header}>
                <h1>Тепловая карта открытых позиций: опционы и фьючерсы</h1>
            </div>
            <div className={classes.container}>
                <Breadcrumbs
                    contrast={false}
                    items={[
                        { href: links.home.url(), title: 'Главная' },
                        { href: links.servicePage.url(), title: 'Сервисы инвестора' },
                        { title: 'Тепловая карта' },
                    ]}
                />
                <p className={classes.text}>
                    Тепловая карта опционов &ndash; это простой и наглядный инструмент, чтобы следить за оборотом и
                    открытыми позициями в опционах на Срочном рынке Московской Биржи. Таблицу можно настраивать по
                    разным параметрам:
                </p>
                <ul className={classes.text}>
                    <li>
                        Вы можете выбрать опционы на любой базовый актив, который есть на срочном рынке: индексы, акции,
                        металлы, валюта
                    </li>
                    <li>Вы можете смотреть на коллы, путы или сумму по ним</li>
                    <li>Вы можете строить тепловую карту по открытому интересу или по обороту</li>
                    <li>ОИ и оборот можно показывать в абсолютных величинах, а можно в процентах</li>
                </ul>
                <p className={classes.text}>
                    Тепловую карту можно использовать как индикатор активности. В любой момент вы можете увидеть, какие
                    опционы пользуются спросом.
                </p>
            </div>
            <iframe
                title="heatmap"
                src="https://fo-heatmap.ru/index.html"
                frameBorder="0"
                width="100%"
                height="4300px"
            ></iframe>
        </>
    );
};

const styles = (theme: ITheme) =>
    createStyles({
        header: {
            ...pageHeader(theme),
        },
        container: {
            ...container(theme),
        },
        text: {
            fontSize: 0.9 + 'rem',
        },
    });

export default injectSheet(styles)(Heatmap);
